
export default {
  name: 'base-section',
};
